/* eslint-disable prettier/prettier */
(function (algolia) {
  'use strict';

  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const {
    config,
    translations,
    headerTemplate,
    productTemplate,
    footerTemplate,
  } = algolia;

  // Filters for stock policy
  let stockPolicyFilter = '';

  if (algolia.config.stock_policy === 'deny') {
    // For 'deny' we will filter out all items based on inventory quantity
    stockPolicyFilter = 'inventory_quantity > 0';
  } else if (algolia.config.stock_policy === 'continue') {
    /**
     * For 'continue' we will filter on `inventory_available` attribute whose
     * value is dependent on:
     * `inventory_quantity > 0 OR inventory_policy == 'continue'`
     */
    stockPolicyFilter = 'inventory_available:true';
  }

  const debounce = (cb, delay = 1000) => {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args)
      }, delay)
    }
  };

  const renderVueItem = () => {
    const elVue = ".aa-Item__vue:not([data-vue-root='ProductAlgolia'][data-v-app])";
    const elDataVueRoot = document.querySelectorAll(elVue);
    if (elDataVueRoot.length) {
      setTimeout(() => {
        window.renderVueApps(elVue);
      }, 500)
    }
  };

  const mountVueItems = (newEl) => {
    const ulContent = document.querySelector('#autocomplete-vue-list');
    if (ulContent && newEl) {
      ulContent.insertAdjacentHTML('beforeend', newEl);
    }
    renderVueItem();
  };

  const manageVueItem = debounce((items) => {
    if(items.length) {
      const elWithHandle = document.querySelectorAll('#autocomplete-vue-list [data-handle]');
      const handlesRendered = [...elWithHandle].map(el => el.dataset.handle);

      // Hide elements don't match with result
      const handlesToHide = handlesRendered.filter(handle => !items.find(item => item.handle === handle));
      handlesToHide.forEach(handle => {
        const elToHide = document.querySelector(`#autocomplete-vue-list [data-handle="${handle}"]`);
        elToHide?.classList?.add('hide');
      });

      // Show element match with result
      const handlesToShow = handlesRendered.filter(handle => items.find(item => item.handle === handle));
      handlesToShow.forEach(handle => {
        const elToShow = document.querySelector(`#autocomplete-vue-list [data-handle="${handle}"]`);
        // Remove hide if exist
        if (elToShow?.classList?.contains('hide')) {
          elToShow?.classList?.remove('hide');
        }
      });

      // Create el if doesn't exist
      const itemsToCreate = items.filter(item => !handlesToShow.includes(item.handle));
      let newEl = '';
      itemsToCreate.forEach(item => {
        // Live-filter mode: product cards are plain list items (not listbox
        // options) so the controls inside each card stay fully navigable.
        newEl += `
          <li class="aa-Item" data-handle="${item.handle}">
            <div class="aa-Item__vue" data-vue-root="ProductAlgolia">
              <product-algolia handle="${item.handle}"></product-algolia>
            </div>
          </li>
        `;
      });

      // Mount results
      const ulContent = document.querySelector('#autocomplete-vue-list');
      if(!ulContent) {
        setTimeout(() => {
          mountVueItems(newEl);
        }, 500)
      }
      else {
        mountVueItems(newEl);
      }

    }
  }, 500);

  algolia.productsPlugin = {
    getSources({ query, setContext }) {
      return [
        {
          sourceId: 'products',
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + 'products',
                  query,
                  params: {
                    hitsPerPage: config.products_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled,
                    filters: stockPolicyFilter,
                    distinct: algolia.config.show_products,
                  },
                },
              ],
              transformResponse({ results, hits }) {
                setContext({
                  nbProducts: results[0].nbHits,
                });
                return hits;
              },
            });
          },
          templates: {
            header({ html, state }) {
              const resource = translations.products;
              return headerTemplate({ html, state }, resource);
            },
            item({ item, html, components }) {
              const distinct = config.show_products;
              const variantInfo =
                !distinct && item.objectID !== item.id
                  ? `?variant= ${item.objectID}`
                  : '';
              const itemLink = `/products/${item.handle}/${variantInfo}`;
              const getConversionData = (e, item) => {
                if (!algolia.config.analytics_enabled) return;

                algolia.saveForConversionTracking({
                  eventName: 'Added to cart',
                  index: item.__autocomplete_indexName,
                  objectIDs: [item.objectID],
                  queryID: item.__autocomplete_queryID,
                });
                
              };

              return productTemplate(
                { item, html, components },
                distinct,
                itemLink,
                getConversionData
              );
            },
            footer({ items, html }) {
              manageVueItem(items);
              return footerTemplate({ html });
            },
          },
          onSelect({ setIsOpen }) {
            setIsOpen(true);
          },
        },
      ];
    },
  };
})(window.algoliaShopify);
